import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getProfile = createAsyncThunk(
  "getProfile/getProfile",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("profile");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const getProfileSlice = createSlice({
  name: "getProfile",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
          
          console.log(action, "success");
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getProfile.rejected, (state, action) => {
        console.log("error", action);
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getProfileSlice.reducer;
